import { __assign, __read, __rest, __spread } from "tslib";
import { KEEN_VALUE } from '../../constants';
export var transformCategoricalNominal = function (_a) {
    var result = _a.result;
    var data = [];
    var keys = new Set();
    keys.add(KEEN_VALUE);
    result.forEach(function (_a) {
        var _b;
        var nominalValues = _a.result, properties = __rest(_a, ["result"]);
        var record = __assign((_b = {}, _b[KEEN_VALUE] = nominalValues, _b), properties);
        data.push(record);
        Object.keys(properties).forEach(function (key) { return keys.add(key); });
    });
    return {
        data: data,
        keys: __spread(keys),
    };
};
